// import {mapGetters} from 'vuex'
import httpService from "../../service";
import Globals from "../../globals.js";
import { i18n } from "../../../main.js";
import Vuex from "vuex";
// import { data } from '../../../store/plano/data'
// import { mapActions } from 'vuex'
import { bus } from "../../../main"; // eslint-disable-line no-unused-vars
import Vue from "vue";

import Toast from "vue-easy-toast";

Vue.use(Toast);
const d3 = require("d3");

export const builderMixin = {
    data: () => ({
        modulePlano: {},
        id: "",
        modeShades: "iconscolors"
    }),
    methods: {
        ...Vuex.mapActions({
            addSelectModule: "plano/status/addSelectModule",
            deleteSelectModule: "plano/status/deleteSelectModule",
            deleteAllModules: "plano/status/deleteAllModules",
            deleteAllModulesElt: "plano/status/deleteAllModulesElt",
            setGroupSelected: "plano/status/setGroupSelected",
            addModule: "plano/status/addModule",
            saveGroup: "plano/status/saveGroup",
            setModuleEdit: "plano/status/setModuleEdit",
            deleteScratchModule: "plano/status/deleteScratchModule",
            addAccessory: "plano/status/addAccessory",
            deleteAccessory: "plano/status/deleteAccessory",
            addAccessorySelected: "plano/status/addAccessorySelected",
            deleteAccessorySelected: "plano/status/deleteAccessorySelected",
            getDetails: "items/getDetails"
        }),
        assign(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        UUID() {
            let s = [];
            let itoh = "0123456789ABCDEF";
            for (let i = 0; i < 36; i++) {
                s[i] = Math.floor(Math.random() * 0x10);
            }

            s[14] = 4;
            s[19] = (s[19] & 0x3) | 0x8;

            for (let j = 0; j < 36; j++) {
                s[j] = itoh[s[j]];
            }

            s[8] = s[13] = s[18] = s[23];

            return s.join("");
        },
        includesPosition(array, object) {
            let res;
            for (let i = 0, l = array.length; i < l; i++) {
                res = array[i];
                if (res.x === object.x && res.y === object.y) return true;
            }

            return false;
        },
        isGroupSelected() {
            let groupSelect = this.getGroupSelected;
            let modules = this.getSelectModules;
            let valid = true;
            if (modules.length === 1) {
                valid = true;
            } else {
                if (groupSelect !== null) {
                    let group;
                    for (let i = 0; i < modules.length; i++) {
                        group = this.getGroupByModule(d3.select(modules[i]).data()[0]);
                        if (group.id !== groupSelect.id) {
                            valid = false;
                            break;
                        }
                    }
                } else {
                    valid = false;
                }
            }
            if (valid === false) alert("Attention: On peut seulement dupliquer un groupe");
            return valid;
        },
        /**
         *
         * @param positions
         * @return {Array} return les position valide pour un module coller
         */
        getPositionValid(positions) {
            let poss = [];
            let possTmp = [];
            let x1, x2, x3, x4, y1, y2, y3, y4;

            positions.forEach(position => {
                x1 = position.x;
                y1 = position.y - 1;
                x2 = position.x - 1;
                y2 = position.y;
                x3 = position.x;
                y3 = position.y + 1;
                x4 = position.x + 1;
                y4 = position.y;

                possTmp.push({ x: x1, y: y1 });
                possTmp.push({ x: x2, y: y2 });
                possTmp.push({ x: x3, y: y3 });
                possTmp.push({ x: x4, y: y4 });

                possTmp.forEach(posTmp => {
                    if (this.includesPosition(positions, posTmp) === false && this.includesPosition(poss, posTmp) === false) {
                        poss[poss.length] = posTmp;
                    }
                });
            });

            return poss;
        },
        canCreateGroup() {
            let modules = this.getSelectModules;
            let module;
            let data;
            let poss = {};
            let possValid = [];
            let pos;
            let positions;

            let valid = true;
            for (let i = 0; i < modules.length; i++) {
                module = modules[i];
                data = d3.select(module).data()[0];

                poss[data.UUID] = {
                    positions: this.getPosModule(data),
                    valid: false
                };

                possValid[possValid.length] = {
                    uuid: data.UUID,
                    positions: this.getPositionValid(this.getPosModule(data))
                };
            }

            for (let i = 0; i < modules.length; i++) {
                module = modules[i];
                data = d3.select(module).data()[0];
                pos = poss[data.UUID];
                possValid.forEach(posValid => {
                    positions = posValid.positions;
                    positions.forEach(posi => {
                        if (posi.uuid !== data.UUID) {
                            if (this.includesPosition(pos.positions, posi)) {
                                pos.valid = true;
                            }
                        }
                    });
                });
            }

            let keys = Object.keys(poss);
            let key;
            for (let i = 0; i < keys.length; i++) {
                key = keys[i];
                pos = poss[key];
                if (pos.valid === false) {
                    valid = false;
                    break;
                }
            }

            if (valid) {
            }
            return valid;
        },
        /**
         *
         * @param x
         * @param y
         * @return Node return le rectancle a la position de la souris
         */
        getRectByPos(x, y) {
            let elts = document.elementsFromPoint(x, y);
            let rect = null;
            let elt;
            for (let i = 0, l = elts.length; i < l; i++) {
                elt = elts[i];
                if (elt.id === "contentMenu" || elt.id === "scratchPad" || elt.id === "favorite") {
                    return null;
                }
            }
            for (let i = 0, l = elts.length; i < l; i++) {
                elt = elts[i];
                if (elt.nodeName === "rect" && elt.getAttribute("class") === "rect-content-module") {
                    rect = elt;
                    break;
                }
            }

            return rect;
        },
        /**
         *
         * @param posX
         * @param posY
         * @return Node return le rectangle a la position ou il est du plano
         */
        getRectByPosition(posX, posY) {
            let rects = d3
                .select("#meubleInt")
                .selectAll(".rect-content-module")
                .nodes();
            let rect = null;
            let d;
            let res = null;

            for (let i = 0, l = rects.length; i < l; i++) {
                rect = rects[i];
                d = d3.select(rect).data()[0];
                if (d.posX === posX && d.posY === posY) {
                    res = rect;
                    break;
                }
            }
            return res;
        },
        getRectSegByPos(x, y) {
            let elts = document.elementsFromPoint(x, y);
            let rect = null;
            let elt;
            for (let i = 0, l = elts.length; i < l; i++) {
                elt = elts[i];
                if (elt.id === "contentMenu" || elt.id === "scratchPad" || elt.id === "favorite") {
                    return null;
                }
            }
            for (let i = 0, l = elts.length; i < l; i++) {
                elt = elts[i];
                if (elt.nodeName === "rect" && elt.getAttribute("class") === "rect-grid-seg") {
                    rect = elt;
                    break;
                }
            }

            return rect;
        },
        getRectSegmentationPosition(posX, posY) {
            let rects = d3
                .select("#meubleInt")
                .selectAll("rect.rect-grid-seg")
                .nodes();
            let rect = null;
            let d;
            let res = null;

            for (let i = 0, l = rects.length; i < l; i++) {
                rect = rects[i];
                d = d3.select(rect).data()[0];
                if (d.posX === posX && d.posY === posY) {
                    res = rect;
                    break;
                }
            }
            return res;
        },
        /**
         * @param moduleData
         * @return retourne toute les positions x et y qui occupe
         */
        getPosModule(moduleData) {
            return this.getPositions(moduleData.posX, moduleData.posY, moduleData);
        },
        getPosAccessory(accessoryData) {
            return this.getPositions(accessoryData.posX, accessoryData.posY, accessoryData);
        },
        getPositions(posX, posY, dataMod) {
            let poss = [];
            let pos;
            let x;
            for (let i = 0; i < dataMod.size.width; i++) {
                pos = {};
                x = posX + i;
                pos.x = x;

                for (let j = 0; j < dataMod.size.height; j++) {
                    if (j === 0) {
                        pos.y = posY + j;
                        poss[poss.length] = pos;
                    } else {
                        pos = {};
                        pos.x = x;
                        pos.y = posY + j;
                        poss[poss.length] = pos;
                    }
                }
            }
            // console.log(poss, dataMod)
            return poss;
        },
        hasAccessoryPos(posX, posY, dataAccessoryCurrent) {
            let accessories = this.getAccessories;
            // if (!accessories.includes(dataAccessoryCurrent)) {
            let accessory;
            let positions, position, positionCurrent;
            let possitionsCurrent = this.getPosAccessory(dataAccessoryCurrent);

            for (let i = 0; i < accessories.length; i++) {
                accessory = accessories[i];
                if (accessory.subtype === "31") continue;
                if (accessory !== dataAccessoryCurrent) {
                    positions = this.getPosAccessory(accessory);
                    for (let j = 0; j < possitionsCurrent.length; j++) {
                        positionCurrent = possitionsCurrent[j];
                        for (let k = 0; k < positions.length; k++) {
                            position = positions[k];
                            if (position.x === positionCurrent.x && position.y === positionCurrent.y) {
                                alert("On ne peut pas mettre un accessoire a cette position elle est déjà occupé");
                                return true;
                            }
                        }
                    }
                }
            }
            // }

            return false;
        },
        hasModulesPos(posX, posY, modules) {
            // let modulesAll = this.getModules
            let module;
            for (let i = 0; i < modules.length; i++) {
                module = modules[i];
                if (this.hasModulePos(posX, posY, module, modules)) {
                    return true;
                }
            }

            return false;
        },
        hasModulePos(posX, posY, moduleCurrent, modulesCurrent = null) {
            let modules = this.getModules;
            let data;
            let mod;
            let valid;
            let dataCurrent = d3.select(moduleCurrent).data()[0];
            // console.log(posX, posY)
            let possModCurrent = this.getPositions(posX, posY, dataCurrent);
            let posModCurrent;
            let horiPitchRepeat = this.getMeuble.plano ? this.getMeuble.plano.steps[1].repeat : this.getMeuble.steps[1].repeat;
            let vertPitchRepeat = this.getMeuble.plano ? this.getMeuble.plano.steps[1].repeat : this.getMeuble.steps[0].repeat;
            // let posXtmp
            // let posYtmp
            let possMod;
            let posMod;
            for (let i = 0; i < modules.length; i++) {
                mod = modules[i];
                if (modulesCurrent !== null) {
                    valid = modulesCurrent.includes(mod) === false && moduleCurrent !== mod;
                } else {
                    valid = moduleCurrent !== mod;
                }

                if (valid) {
                    data = d3.select(mod).data()[0];
                    possMod = this.getPosModule(data);
                    if (data.type === dataCurrent.type) {
                        for (let j = 0; j < possModCurrent.length; j++) {
                            posModCurrent = possModCurrent[j];
                            for (let k = 0; k < possMod.length; k++) {
                                posMod = possMod[k];
                                if (posModCurrent.x === posMod.x && posModCurrent.y === posMod.y) {
                                    alert("On ne peut pas mettre un module a cette position elle est déjà occupé");
                                    return true;
                                }
                            }
                        }
                    }
                }
            }

            for (let j = 0; j < possModCurrent.length; j++) {
                posModCurrent = possModCurrent[j];
                if (posModCurrent.x >= horiPitchRepeat || posModCurrent.y >= vertPitchRepeat) {
                    alert("Attention: le module sort du plano");
                    return true;
                }
            }
            return false;
        },
        mixinTest() {},
        upBuilderField(field, value) {
            this.$store.commit("plano/status/updateBuilder", { field, value });
        },
        getElementDimensions(el) {
            return { height: this.$refs[el].clientHeight, width: this.$refs[el].clientWidth };
        },
        // Drag & Drop du Menu vers le Plano
        getGroupById(id) {
            let groups = this.getGroups();
            let group;
            for (let i = 0, l = groups.length; i < l; i++) {
                group = groups[i];
                if (group.id === id) {
                    return group;
                }
            }
            return null;
        },
        addGroupAuto(moduleSvg, uuid = this.UUID()) {
            if (this.getModules.includes(moduleSvg) === false) {
                this.addModule(moduleSvg);
            }
            let dataModule = d3.select(moduleSvg).data()[0];
            let groupId = uuid;
            let groupExist = this.getGroupById(uuid);
            let group = {
                id: groupId,
                modules: []
            };

            if (groupExist !== null) {
                group = groupExist;
            }

            dataModule.groupId = groupId;
            d3.select(moduleSvg).datum(dataModule);
            group.modules.push(dataModule);
            if (groupExist === null) {
                this.saveGroup(group);
            }

            return uuid;
        },
        getSizeContentModule() {
            let rect = this.getRectByPosition(0, 0);
            let bbContentMod = rect.parentNode.getBBox();
            let g = d3.select("g#contentPlanoMain").node();
            let bb = g.getBoundingClientRect();
            let svgPlano = d3.select("svg#builder");
            let viewBox = svgPlano.attr("viewBox");
            let size = viewBox.split(" ");
            let widthViewBoxSvg = parseInt(size[2], 10);
            let heightViewBoxSvg = parseInt(size[3], 10);

            let width = bbContentMod.width * (bb.width / widthViewBoxSvg);
            let height = bbContentMod.height * (bb.height / heightViewBoxSvg);
            return { width: width, height: height };
        },
        getSizeContentSegmentation() {
            let rectSeg = d3.select("rect#segmentation");
            if (rectSeg.size() > 0) {
                let rect = this.getRectSegmentationPosition(0, 0);
                if (rect !== null) {
                    let rectData = d3.select(rect).data()[0];
                    let g = d3.select("g#contentPlanoMain").node();
                    let bb = g.getBoundingClientRect();

                    let svgPlano = d3.select("svg#builder");
                    let viewBox = svgPlano.attr("viewBox");
                    let size = viewBox.split(" ");
                    let widthViewBoxSvg = parseInt(size[2], 10);
                    let heightViewBoxSvg = parseInt(size[3], 10);

                    let width = parseInt(rectData.width, 10) * (bb.width / widthViewBoxSvg);
                    let height = parseInt(rectData.height, 10) * (bb.height / heightViewBoxSvg);
                    return { width: width, height: height };
                }
            }

            return null;
        },
        copy(index, event) {
            let item = event.target;

            let contentMenu = document.querySelector("#contentMenu");
            let resultsWrapper = document.querySelector("#resultsWrapper");
            let bbContent = contentMenu.getBoundingClientRect();
            let bbResWra = resultsWrapper.getBoundingClientRect();
            let moduleSize = item.getAttribute("modulesize");
            let type = item.getAttribute("component_type");
            let subtype = item.getAttribute("component_subtype");
            let modSizeWidth = moduleSize ? parseInt(moduleSize.split(",")[0], 10) : 1;
            let modSizeHeight = moduleSize ? parseInt(moduleSize.split(",")[1], 10) : 1;
            let itemCopy = item.cloneNode(true);
            let sizeContentMod = null;
            let isSegmentation = type === "accessory" && subtype === "31";
            let text = "";
            if (isSegmentation) {
                sizeContentMod = this.getSizeContentSegmentation();
                text = item.firstChild.nodeValue;
                itemCopy.style.textAlign = "center";
            } else {
                sizeContentMod = this.getSizeContentModule();
            }
            let width = sizeContentMod.width * modSizeWidth;
            let height = sizeContentMod.height * modSizeHeight;
            this.copyItem = true;
            itemCopy.style.height = height + "px";
            itemCopy.style.width = width + "px";
            itemCopy.style.position = "absolute";
            itemCopy.style.zIndex = 3000;
            itemCopy.classList.remove("img-fluid");

            itemCopy.id = "copy_" + event.target.id;
            itemCopy.id = "copy_" + item.id;

            let container = document.querySelector("#builderWrapper");
            container.appendChild(itemCopy);
            let diffX = 10;
            let id = item.id.split("item_")[1];
            let h = bbContent.height - bbResWra.height; // bbResWra.y
            let y = event.clientY - h;
            let x = event.clientX - diffX;

            let data = {
                x: x,
                y: y,
                diffX: diffX,
                diffY: height / 4,
                size: { width: modSizeWidth, height: modSizeHeight },
                id: id,
                type: item.getAttribute("component_type"),
                text: text
            };
            let itemCopD3 = d3
                .select(itemCopy)
                .raise()
                .data([data]);
            if (isSegmentation) {
                this.drag(itemCopD3, null, null, this.endedSeg);
            } else {
                this.drag(itemCopD3);
            }
            let init = {
                bubbles: true,
                cancelable: true,
                view: window
            };
            let evt = new MouseEvent("mousedown", init);

            itemCopy.dispatchEvent(evt);
        },
        copyFav(event, objectScratchpad) {
            let item = objectScratchpad.svg;
            let bbContent = item.getBoundingClientRect();
            let y = event.clientY - bbContent.height;
            let x = event.clientX;
            let modSizeWidth = objectScratchpad.size.width;
            let modSizeHeight = objectScratchpad.size.height;
            let itemCopy = item.cloneNode(true);
            itemCopy.id = "copy_" + this.UUID();

            let sizeContentMod = this.getSizeContentModule();
            let width = sizeContentMod.width * modSizeWidth;
            let height = sizeContentMod.height * modSizeHeight;

            this.copyItem = true;

            itemCopy.style.height = height + "px";
            itemCopy.style.width = width + "px";
            itemCopy.style.position = "absolute";
            itemCopy.style.zIndex = 3000;

            let mod;
            let dataMod;
            let modules = objectScratchpad.modules;
            let uuid;
            let dataModCop;
            let itemCopyD3 = d3.select(itemCopy);
            itemCopyD3
                .select("g")
                .selectAll("svg.module_snap")
                .each((d, i, cmps) => {
                    uuid = "elt_" + this.UUID();
                    mod = cmps[i];
                    mod.id = uuid;
                    dataMod = modules[i].data;
                    dataModCop = this.assign(dataMod);
                    dataModCop.UUID = uuid;
                    d3.select(mod).data([dataModCop]);
                });

            itemCopy.classList.remove("img-fluid");

            let container = document.querySelector("#workingSpace");
            container.appendChild(itemCopy);
            // console.log(event, height, width)
            this.drag(
                d3
                    .select(itemCopy)
                    .raise()
                    .data([
                        {
                            x: x,
                            y: y,
                            size: { width: modSizeWidth, height: modSizeHeight },
                            diffX: width / 4,
                            diffY: bbContent.height
                        }
                    ]),
                null,
                null,
                (d, i, cpms) => {
                    this.dragEndFav(d, i, cpms, objectScratchpad);
                }
            );
            let init = {
                bubbles: true,
                cancelable: true,
                view: window
            };
            let evt = new MouseEvent("mousedown", init);

            itemCopy.dispatchEvent(evt);
        },
        round(p, n) {
            return p % n < n / 2 ? p - (p % n) : p + n - (p % n);
        },
        drag(elt, start = null, dragged = null, end = null) {
            let drag = d3
                .drag()
                .on("start", start === null ? this.started : start)
                .on("drag", dragged === null ? this.dragged : dragged)
                .on("end", end === null ? this.ended : end);
            elt.call(drag);
        },
        started(d, i, cmps) {
            let img = cmps[i];
            d3.select(img).classed("dragging", true);
            // .attr('x', )
            img.style.left = d.x + "px";
            img.style.top = d.y + "px";
        },
        dragged(data, i, cmps) {
            // let sizeContentMod = this.getSizeContentModule()
            // let width = sizeContentMod.width
            // let height = sizeContentMod.height
            // let r = this.getMeuble.steps[1].length
            let img = cmps[i];

            let x = 0;
            let y = 0;
            x = d3.event.sourceEvent.clientX;
            y = d3.event.sourceEvent.clientY;

            data.x = x - data.diffX;
            data.y = y - data.diffY;

            img.style.left = data.x + "px";
            img.style.top = data.y + "px";
        },
        endedSeg(d, i, cmps) {
            let img = cmps[i];
            let idModule = img.id.split("item_")[1];
            let uuid = "elt_" + this.UUID();
            let event = d3.event;
            let dataImg = d;
            let type = img.getAttribute("component_type");
            let subtype = img.getAttribute("component_subtype");
            let rect = this.getRectSegByPos(event.sourceEvent.pageX, event.sourceEvent.pageY);
            if (rect !== null) {
                let data = d3.select(rect).data()[0];
                let accessoryColor = img.getAttribute("accessory_color") ? img.getAttribute("accessory_color") : null;
                let dataMod = {
                    x: data.x,
                    y: data.y,
                    type: type,
                    subtype: subtype,
                    posX: data.posX,
                    posY: data.posY,
                    size: dataImg.size,
                    selected: false,
                    id: idModule,
                    UUID: uuid,
                    posInit: { posX: 0, posY: 0 },
                    text: dataImg.text
                };
                dataMod.color = accessoryColor;
                let widthMod = parseInt(rect.getAttribute("width"), 10) * dataImg.size.width;
                let heightMod = parseInt(rect.getAttribute("height"), 10) * dataImg.size.height;
                let g = d3.select("#meubleInt").append("g");
                let frame = g
                    .append("rect")
                    .raise()
                    .data([dataMod])
                    .attr("width", widthMod)
                    .attr("height", heightMod)
                    .attr("stroke", accessoryColor)
                    .attr("stroke-width", 8)
                    .attr("fill", accessoryColor)
                    .attr("id", uuid)
                    .attr("x", data.x)
                    .attr("y", data.y)
                    .attr("class", "accessory-segmentation");
                // console.log(data)
                let text = g
                    .append("text")
                    .raise()
                    .text(dataMod.text)
                    .attr("x", data.x)
                    .attr("y", data.y)
                    // .attr('width', widthMod)
                    // .attr('height', heightMod)
                    .attr("dy", 35)
                    .attr("fill", "white")
                    .attr("font-size", heightMod);

                let bbText = text.node().getBBox();
                let dx = widthMod / 2 - bbText.width / 2;
                text.attr("dx", dx);
                this.addAccessory(dataMod);
                this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
            }
            img.parentNode.removeChild(img);
        },
        ended(d, i, cmps) {
            let img = cmps[i];
            let idModule = img.id.split("item_")[1];
            let uuid = "elt_" + this.UUID();
            let groupId;
            let copySvg = null;
            let event = d3.event;
            let dataImg = d3.select(img).data()[0];
            let type = img.getAttribute("component_type");
            let subtype = img.getAttribute("component_subtype");
            let rect = this.getRectByPos(event.sourceEvent.pageX, event.sourceEvent.pageY);

            if (rect !== null) {
                let data = d3.select(rect).data()[0];
                // creer si il n
                if (this.hasModulePos(data.posX, data.posY, img) === false) {
                    let accessoryColor = img.getAttribute("accessory_color") ? img.getAttribute("accessory_color") : null;
                    let dataMod = {
                        x: data.x,
                        y: data.y,
                        type: type,
                        subtype: subtype,
                        posX: data.posX,
                        posY: data.posY,
                        size: dataImg.size,
                        selected: false,
                        id: idModule,
                        UUID: uuid,
                        posInit: { posX: 0, posY: 0 },
                        groupId: null,
                        visual: null
                    };

                    if (type === "module") {
                        dataMod.src = img.src;
                        dataMod.srcreal = img.getAttribute("srcreal");
                        dataMod.timestamp = parseInt(img.getAttribute("timestamp"), 10);
                    }
                    if (type === "accessory" && accessoryColor !== null) {
                        dataMod.color = accessoryColor;
                    }
                    let widthMod = parseInt(rect.getAttribute("width"), 10) * dataImg.size.width;
                    let heightMod = parseInt(rect.getAttribute("height"), 10) * dataImg.size.height;

                    if (type === "module") {
                        this.eltSvg(img.src).then(domXml => {
                            let gContentModule = d3
                                .select("#meubleInt")
                                .append("g")
                                .raise();
                            gContentModule.node().append(domXml);
                            copySvg = d3
                                .select(domXml)
                                .data([dataMod])
                                // .raise()
                                .attr("width", widthMod)
                                .attr("height", heightMod)
                                .attr("id", uuid)
                                .attr("x", data.x)
                                .attr("y", data.y)
                                .attr("class", "grab module_snap");

                            groupId = this.addGroupAuto(domXml);
                            gContentModule.data([
                                {
                                    groupId: groupId,
                                    selected: false
                                }
                            ]);
                            this.drag(copySvg, this.dragStartSVG, this.dragSVG, this.dragEndSVG);
                        });
                    } else {
                        // console.log(accessoryColor)
                        if (this.hasAccessoryPos(data.posX, data.posY, dataMod) === false) {
                            let frame = d3
                                .select("#meubleInt")
                                // .append('g')
                                // .raise()
                                .append("rect")
                                .raise()
                                .data([dataMod])
                                .attr("width", widthMod)
                                .attr("height", heightMod)
                                .attr("stroke", accessoryColor)
                                .attr("stroke-width", 10)
                                .attr("fill-opacity", 0)
                                .attr("id", uuid)
                                .attr("x", data.x)
                                .attr("y", data.y)
                                .attr("class", "accessory-frame");
                            this.addAccessory(dataMod);
                            this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                        }
                    }
                }
                d3.select("#meubleInt")
                    .selectAll("rect.accessory-frame")
                    .raise();
            }
            img.parentNode.removeChild(img);
        },
        dragStartAccessory(d, i, cmps) {
            this.clickSelectionAccessory(d, i, cmps);
            let isSegmentation = d.subtype === "31";
            let rect = isSegmentation
                ? this.getRectSegByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY)
                : this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            let dataRect = d3.select(rect).data()[0];
            let posXOrigin = d.posX - dataRect.posX;
            let posYOrigin = d.posY - dataRect.posY;
            let origin = { posX: posXOrigin, posY: posYOrigin };
            if (isSegmentation) d.mouseY = d3.event.sourceEvent.pageY;
            d.posInit = origin;
            let accessoiry = cmps[i];
            let accessoiryD3 = d3.select(accessoiry);
            accessoiryD3.raise();

            accessoiryD3
                .attr("x", (data, i, cmps) => {
                    return data.x;
                })
                .attr("y", data => {
                    return data.y;
                });
        },
        dragAccessory(d, i, cmps) {
            let x = d3.event.x;
            let y = d3.event.y;
            let accessory = cmps[i];
            let g = accessory.parentNode;
            d3.select(cmps[i])
                .attr("x", data => {
                    if (data.subtype === "31")
                        d3.select(g)
                            .select("text")
                            .attr("x", x);
                    return x;
                })
                .attr("y", data => {
                    if (data.subtype === "31") {
                        return data.y;
                    } else {
                        return y;
                    }
                });
        },
        dragEndAccessory(data, i, cmps) {
            let isSegmentation = data.subtype === "31";
            let rect = isSegmentation
                ? this.getRectSegByPos(d3.event.sourceEvent.pageX, data.mouseY)
                : this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            if (isSegmentation) delete data.mouseY;
            let frame = cmps[i];
            let frameD3 = d3.select(frame).raise();
            let valid = true;

            if (rect !== null) {
                let dataRect = d3.select(rect).data()[0];
                let rectAlt = isSegmentation
                    ? this.getRectSegmentationPosition(dataRect.posX + data.posInit.posX, dataRect.posY + data.posInit.posY)
                    : this.getRectByPosition(dataRect.posX + data.posInit.posX, dataRect.posY + data.posInit.posY);
                let dataRectAlt = d3.select(rectAlt).data()[0];
                frameD3
                    .attr("x", d => {
                        d.x = dataRectAlt.x;
                        d.posX = dataRectAlt.posX;
                        if (isSegmentation) {
                            let g = frame.parentNode;
                            d3.select(g)
                                .select("text")
                                .raise()
                                .attr("x", dataRectAlt.x);
                        }
                        return d.x;
                    })
                    .attr("y", d => {
                        if (!isSegmentation) {
                            d.y = dataRectAlt.y;
                            d.posY = dataRectAlt.posY;
                        }
                        return d.y;
                    });
                // }
            } else {
                valid = false;
            }

            if (valid === false) {
                frameD3
                    .attr("x", d => {
                        if (isSegmentation) {
                            let g = frame.parentNode;
                            d3.select(g)
                                .select("text")
                                .raise()
                                .attr("x", d.x);
                        }
                        return d.x;
                    })
                    .attr("y", d => {
                        return d.y;
                    });
            }
        },
        dragEndFav(data, i, cmps, objectScratchpad) {
            let svg = cmps[i];
            let rect = this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            let valid = true;

            if (rect !== null) {
                let groupId = this.UUID();
                let dataRect = d3.select(rect).data()[0];
                let posX;
                let posY;
                let rectAlt;
                let dataRectAlt;
                let modules = d3
                    .select(svg)
                    .select("g")
                    .selectAll("svg.module_snap");
                let gContentModule = d3
                    .select("#meubleInt")
                    .append("g")
                    .raise();
                gContentModule.data([
                    {
                        groupId: groupId,
                        selected: false
                    }
                ]);
                let uuidMod;
                modules.each((d, i, cmps) => {
                    if (valid === false) return false;
                    let resX = d.posX;
                    let resY = d.posY;
                    posX = resX + dataRect.posX;
                    posY = resY + dataRect.posY;
                    rectAlt = this.getRectByPosition(posX, posY);
                    dataRectAlt = d3.select(rectAlt).data()[0];
                    if (rectAlt === null || this.hasModulesPos(dataRectAlt.posX, dataRectAlt.posY, modules.nodes()) === true) {
                        valid = false;
                        return false;
                    }
                });

                if (valid) {
                    let modD3;
                    modules.each((data1, i, cmps) => {
                        this.eltSvg(data1.src).then(mod => {
                            uuidMod = "elt_" + this.UUID();
                            modD3 = d3.select(mod);
                            let dataCop = this.assign(data1);
                            let resX = dataCop.posX;
                            let resY = dataCop.posY;
                            posX = resX + dataRect.posX;
                            posY = resY + dataRect.posY;
                            dataCop.groupId = null;
                            dataCop.selected = false;
                            dataCop.UUID = uuidMod;
                            let widthMod = dataRect.width * dataCop.size.width;
                            let heightMod = dataRect.height * dataCop.size.height;
                            rectAlt = this.getRectByPosition(posX, posY);
                            dataRectAlt = d3.select(rectAlt).data()[0];
                            gContentModule.node().append(mod);

                            // modD3.data([dataModCop])

                            modD3
                                .data([dataCop])
                                .attr("id", uuidMod)
                                .attr("width", widthMod)
                                .attr("height", heightMod)
                                .attr("class", "grab module_snap")
                                .attr("x", d => {
                                    d.x = dataRectAlt.x;
                                    d.posX = dataRectAlt.posX;
                                    return d.x;
                                })
                                .attr("y", d => {
                                    d.y = dataRectAlt.y;
                                    d.posY = dataRectAlt.posY;
                                    return d.y;
                                });
                            this.addGroupAuto(mod, groupId);
                            this.loadConfigModule(mod, dataCop);
                            this.createVirtualComponent(modD3.node());
                            this.drag(modD3, this.dragStartSVG, this.dragSVG, this.dragEndSVG);
                        });
                    });

                    if (objectScratchpad.isScratchpad === true) {
                        objectScratchpad.svg.parentNode.removeChild(objectScratchpad.svg);
                        this.deleteScratchModule(objectScratchpad);
                    }
                }
            }
            d3.select(svg).remove();
        },
        copies(elts) {
            let g = d3
                .select("#meubleInt")
                .append("g")
                .raise();

            let eltCop;
            let data;
            let dataCop;
            let groupId = this.UUID();
            elts.forEach(elt => {
                data = d3.select(elt).data()[0];

                let uuid = "elt_" + this.UUID();

                dataCop = this.assign(data);
                dataCop.groupdId = null;
                dataCop.UUID = uuid;
                dataCop.selected = false;
                eltCop = elt.cloneNode(true);

                g.node().append(eltCop);
                d3.select(eltCop)
                    .data([dataCop])
                    .attr("id", uuid)
                    .attr("x", d => {
                        d.x = parseInt(d.x, 10) + 20;
                        return d.x;
                    })
                    .attr("y", d => {
                        d.y = parseInt(d.y, 10) + 20;
                        return d.y;
                    });
                d3.select(eltCop)
                    .select("svg")
                    .attr("visibility", "hidden");
                this.addGroupAuto(eltCop, groupId);
                g.data([
                    {
                        groupId: groupId,
                        selected: false
                    }
                ]);
                this.drag(d3.select(eltCop), this.dragStartSVG, this.dragSVG, this.dragEndSVG);
            });
        },
        dragStartSVG(d, i, cmps) {
            let img = cmps[i];
            let rect = this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            let dataRect = d3.select(rect).data()[0];
            let posXOrigin = d.posX - dataRect.posX;
            let posYOrigin = d.posY - dataRect.posY;
            let origin = { posX: posXOrigin, posY: posYOrigin };
            d.posInit = origin;
            // .classed('dragging', true)
            let g = cmps[i].parentNode;
            let gD3 = d3.select(g);
            gD3.raise();
            if (d.type === "module" || d.type === undefined) {
                this.selectionModule(d, i, cmps);
            }
            gD3.select(".group-selected").attr("visibility", "hidden");

            d3.select(img)
                .attr("x", (data, i, cmps) => {
                    return data.x;
                })
                .attr("y", data => {
                    return data.y;
                });
        },
        dragSVG(data, i, cmps) {
            let tailleX = 20;
            let tailleY = 20;
            let img = cmps[i];

            let x = 0;
            let y = 0;
            let container = d3.select("#meubleInt");
            let bb = container.node().getBBox();
            //
            let bbx = bb.x;
            let bby = bb.y;
            let w = bb.width + bbx;
            let h = bb.height + bby;

            x = d3.event.x;
            y = d3.event.y;

            let gridX;
            let gridY;
            let posXOrigin = data.posX;
            let posYOrigin = data.posY;
            let modules = d3.select(img.parentNode).selectAll(".module_snap");

            modules
                .attr("x", (d, i, cmps) => {
                    let cmp = cmps[i];
                    let width = parseFloat(cmp.getAttribute("width")) / d.size.width;
                    let res = d.posX - posXOrigin;

                    gridX = x + res * width;

                    gridX = this.round(Math.max(bbx, Math.min(w, gridX)), tailleX);
                    return gridX;
                })
                .attr("y", (d, i, cmps) => {
                    let cmp = cmps[i];
                    let height = parseFloat(cmp.getAttribute("height")) / d.size.height;
                    let res = d.posY - posYOrigin;

                    gridY = y + res * height;
                    gridY = this.round(Math.max(bby, Math.min(h, gridY)), tailleY);
                    return gridY;
                });
        },
        dragEndSVG(d, i, cmps) {
            let img = cmps[i];
            let posXOrigin = d.posX - d.posInit.posX;
            let posYOrigin = d.posY - d.posInit.posY;
            let gD3 = d3.select(img.parentNode);

            let modules = gD3.selectAll(".module_snap");
            let rect = this.getRectByPos(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);

            let valid = true;
            if (rect !== null) {
                let dataRect = d3.select(rect).data()[0];
                let posX;
                let posY;
                let rectAlt;
                let mod;
                let dataRectAlt;
                modules.each((d, i, cmps) => {
                    if (valid === false) return false;
                    mod = cmps[i];
                    let resX = d.posX - posXOrigin;
                    let resY = d.posY - posYOrigin;
                    posX = resX + dataRect.posX;
                    posY = resY + dataRect.posY;
                    rectAlt = this.getRectByPosition(posX, posY);

                    dataRectAlt = d3.select(rectAlt).data()[0];
                    if (rectAlt === null || this.hasModulesPos(dataRectAlt.posX, dataRectAlt.posY, modules.nodes()) === true) {
                        valid = false;
                        return false;
                    }
                });

                if (valid) {
                    let posXMin = null;
                    let posYMin = null;
                    modules.each((d, i, cmps) => {
                        mod = cmps[i];
                        let resX = d.posX - posXOrigin;
                        let resY = d.posY - posYOrigin;
                        posX = resX + dataRect.posX;
                        posY = resY + dataRect.posY;
                        rectAlt = this.getRectByPosition(posX, posY);
                        dataRectAlt = d3.select(rectAlt).data()[0];
                        d3.select(mod)
                            .attr("x", d => {
                                d.x = dataRectAlt.x;
                                d.posX = dataRectAlt.posX;
                                if (posXMin === null) {
                                    posXMin = dataRectAlt.x;
                                } else if (posXMin > dataRectAlt.x) {
                                    posXMin = dataRectAlt.x;
                                }
                                return d.x;
                            })
                            .attr("y", d => {
                                d.y = dataRectAlt.y;
                                d.posY = dataRectAlt.posY;

                                if (posYMin === null) {
                                    posYMin = dataRectAlt.y;
                                } else if (posYMin > dataRectAlt.y) {
                                    posYMin = dataRectAlt.y;
                                }
                                return d.y;
                            });
                    });

                    gD3.select("rect.group-selected")
                        .attr("visibility", "visible")
                        .attr("x", posXMin)
                        .attr("y", posYMin);
                }
            } else {
                valid = false;
            }

            if (!valid) {
                gD3.select("rect.group-selected").attr("visibility", "visible");
                // alert('On ne peut pas mettre un module a cette position elle est déjà occupé')
                modules
                    .attr("x", d => {
                        return d.x;
                    })
                    .attr("y", d => {
                        return d.y;
                    });
            }
            d3.select("#meubleInt")
                .selectAll("rect.accessory-frame")
                .raise();
        },
        clickSelectionAccessory(d, i, cmps) {
            if (this.getSelection) {
                let selected = !d.selected;
                this.selectedAccessory(d, selected);
            }
        },
        selectedAccessory(d, selected) {
            let accessoryD3 = d3.select("rect#" + d.UUID);
            if (selected) {
                this.addAccessorySelected(d);
                accessoryD3.attr("stroke", "#41B4E8");
            } else {
                this.deleteAccessorySelected(d);
                accessoryD3.attr("stroke", d.color);
            }
            d.selected = selected;
        },
        selectionModule(d, i, cmps) {
            if (d3.event.defaultPrevented) return;

            let gElt = cmps[i].parentNode;
            let gEltD3 = d3.select(gElt);
            if (this.getSelection) {
                let selected = !d.selected;
                let group = this.getGroupById(d.groupId);
                let modules = group.modules;
                if (modules.length > 1) {
                    this.deselectAll();
                    this.setGroupSelected(selected ? group : null);
                }
                d.selected = selected;
                let elt;
                let bb = gElt.getBBox();

                let rectD3 = gEltD3.select("rect.group-selected");
                if (selected && rectD3.size() === 0) {
                    rectD3 = gEltD3
                        .append("rect")
                        .lower()
                        .attr("class", "group-selected")
                        .attr("stroke", "#41B4E8")
                        .attr("stroke-width", "15")
                        .attr("fill", "#41B4E8")
                        .attr("fill-opacity", 0)
                        .attr("width", bb.width)
                        .attr("height", bb.height)
                        .attr("x", bb.x)
                        .attr("y", bb.y);
                }

                if (selected) {
                    rectD3.attr("visibility", "visible");
                } else {
                    rectD3.remove();
                }

                modules.forEach(mod => {
                    mod.selected = true;
                    elt = d3.select("#" + mod.UUID).node();
                    if (selected) {
                        mod.selected = true;
                        this.addSelectModule(elt);
                    } else {
                        mod.selected = false;
                        this.deleteSelectModule(elt);
                    }
                });
            }
        },
        deselectAll() {
            this.setGroupSelected(null);
            d3.selectAll("rect.group-selected").remove();

            d3.select("#meubleInt")
                .selectAll(".module_snap")
                .each((d, i, cmps) => {
                    d.selected = false;
                    let elt = cmps[i];
                    let g = elt.parentNode;
                    let data = d3.select(g).data()[0];
                    if (data) data.selected = false;
                });
            this.deleteAllModules();
            let accessoriesSeleced = this.getAccessoriesSelected;
            let accessories = [];
            accessoriesSeleced.forEach(accessory => {
                accessories.push(accessory);
            });

            accessories.forEach(accessory => {
                this.selectedAccessory(accessory, false);
            });
        },
        getDataTransformContentPlano() {
            let dataPan = d3.select("#contentPlanoMain").data().length > 0 ? d3.select("#contentPlanoMain").data()[0] : null;
            let transform = dataPan ? dataPan.transform : null;
            return transform;
        },
        clickModule() {
            // this.destroyMenu()
            this.tabhide = false;
            if (this.getSelectModules.length === 0) {
                alert("Attention: il faut séléctionner un module");
                return;
            }
            if (this.getSelectModules.length > 1) {
                Vue.toast("Vous ne pouvez pas éditer 2 modules en même temps", {
                    id: "my-toast-error",
                    className: ["toast-warning", "flexContainer"],
                    horizontalPosition: "right",
                    verticalPosition: "bottom",
                    mode: "queue"
                });
            } else {
                this.displayModule = true;
                let data = d3.select(this.getSelectModules[0]).data()[0];
                this.upBuilderField("mode", "module");
                this.id = data.id;
                this.$store.dispatch("plano/data/getRelatedProducts", { id: this.id }).then(() => {
                    this.displayMenuShades = true;
                });
                this.$store.state.plano.status.builder.idModule = this.id;
                this.setModuleEdit(data);
                this.deselectAll();
                this.deleteAllModulesElt();
                d3.select("svg#builder")
                    .select("g#planoMeuble")
                    .remove();
                d3.select("svg#builder")
                    .select("g#meubleInt")
                    .remove();
            }
        },
        save(a) {
            let objectToSave = {};
            let groups = this.assign(this.getGroups());
            groups.forEach(group => {
                group.modules.forEach(mod => {
                    mod.selected = false;
                });
            });
            let accessories = this.assign(this.getAccessories);

            accessories.forEach(accessory => {
                accessory.selected = false;
            });

            if (this.getMeuble.plano) {
                objectToSave = {
                    content: {
                        plano: this.getMeuble.plano,
                        groups: groups,
                        accessories: accessories
                    }
                };
            } else {
                objectToSave = {
                    content: {
                        plano: this.getMeuble,
                        groups: groups,
                        accessories: accessories
                    }
                };
            }

            httpService.post("/plano/" + this.$route.params.id + "/config", JSON.stringify(objectToSave)).then(response => {
                if (a === "saveExit") {
                    this.$store.state.plano.status.builder.groups = [];
                    this.$router.replace("/planos");
                } else {
                    Vue.toast("SAUVEGARGE REUSSIE", {
                        id: "my-toast",
                        className: ["my-toast", "toast-warning", "flexContainer", "txtCenter"],
                        horizontalPosition: "right",
                        verticalPosition: "bottom",
                        mode: "queue"
                    });
                    this.$store.state.plano.status.builder.modifiedUser = {
                        firstname: response.modifiedUser.firstname,
                        lastname: response.modifiedUser.lastname,
                        date: response.modifiedDate
                    };
                }
            });
        },
        plano(d, i, cmps) {
            let meubleHeightExt = 0;
            let meubleWidthExt = 0;
            let base = 0;
            let front = 0;
            let meubleWidthInt = 0;
            let meubleHeightInt = 0;
            let horiPitch = 0;
            let vertPitch = 0;
            let horiPitchRepeat = 0;
            let vertPitchRepeat = 0;
            let blocks = {};
            let blockWitdh;
            let segWidth = 0;
            let segHeight = 0;
            if (this.getMeuble.plano) {
                meubleHeightExt = this.getMeuble.plano.heightExternal;
                meubleWidthExt = this.getMeuble.plano.widthExternal;
                base = this.getMeuble.plano.base;
                front = this.getMeuble.plano.front;
                meubleWidthInt = this.getMeuble.plano.widthInternal;
                meubleHeightInt = this.getMeuble.plano.heightInternal;
                horiPitch = this.getMeuble.plano.steps[1].length;
                vertPitch = this.getMeuble.plano.steps[0].length;
                horiPitchRepeat = this.getMeuble.plano.steps[1].repeat;
                vertPitchRepeat = this.getMeuble.plano.steps[0].repeat;
                blocks = this.getMeuble.plano.blocks;
                blockWitdh = blocks[0] ? blocks[0].length : 0;
                segWidth = this.getMeuble.plano.segmentation_bar_width;
                segHeight = this.getMeuble.plano.segmentation_bar_height;
            } else {
                meubleHeightExt = this.getMeuble.heightExternal;
                meubleWidthExt = this.getMeuble.widthExternal;
                base = this.getMeuble.base;
                front = this.getMeuble.front;
                meubleWidthInt = this.getMeuble.widthInternal;
                meubleHeightInt = this.getMeuble.heightInternal;
                horiPitch = this.getMeuble.steps ? this.getMeuble.steps[1].length : 0;
                vertPitch = this.getMeuble.steps ? this.getMeuble.steps[0].length : 0;
                horiPitchRepeat = this.getMeuble.steps ? this.getMeuble.steps[1].repeat : 0;
                vertPitchRepeat = this.getMeuble.steps ? this.getMeuble.steps[0].repeat : 0;
                blocks = this.getMeuble.blocks;
                if (blocks) {
                    blockWitdh = blocks[0] ? blocks[0].length : 0;
                    segWidth = this.getMeuble.segmentation_bar_width;
                    segHeight = this.getMeuble.segmentation_bar_height;
                }
            }

            segHeight = !segHeight ? 0 : segHeight;

            let svg = d3.select("svg");
            svg.node().innerHTML = "";

            this.gMain = svg
                .append("g")
                .data([{ transform: null }])
                .raise()
                .attr("id", "contentPlanoMain");

            let g = this.gMain.append("g").attr("id", "planoMeuble");
            g.append("rect")
                .attr("id", "meuble")
                .attr("width", meubleWidthExt)
                .attr("height", meubleHeightExt)
                .attr("x", 0)
                .attr("y", 0)
                .attr("stroke", "black")
                .attr("fill", "white");
            g.append("line")
                .attr("id", "front")
                .attr("x1", 0)
                .attr("y1", front)
                .attr("x2", meubleWidthExt)
                .attr("y2", front)
                .attr("stroke", "black")
                .attr("fill", "white");
            g.append("line")
                .attr("id", "base")
                .attr("x1", 0)
                .attr("y1", meubleHeightExt - base)
                .attr("y2", meubleHeightExt - base)
                .attr("x2", meubleWidthExt)
                .attr("stroke", "black");
            let widthCenter = (meubleWidthExt - meubleWidthInt) / 2;
            let heightCenter = (meubleHeightExt - (front + base) - meubleHeightInt) / 2;
            let gContainer = this.gMain
                .append("g")
                .data([{ x: widthCenter, y: heightCenter }])
                .attr("id", "meubleInt")
                .attr("transform", "translate(" + widthCenter + "," + heightCenter + ")");

            gContainer
                .append("rect")
                .attr("id", "rectInt")
                .attr("width", meubleWidthInt)
                .attr("height", meubleHeightInt)
                .attr("stroke", "black")
                .attr("x", 0)
                .attr("y", front)
                .attr("fill", "white");
            // barre de segmentation
            if (segHeight !== 0) {
                gContainer
                    .append("rect")
                    .attr("id", "segmentation")
                    .attr("x", 0)
                    .attr("y", front)
                    .attr("width", segWidth)
                    .attr("height", segHeight)
                    .attr("fill", "#343434");
                // création de la grille

                let data2 = [];
                for (let j in d3.range(0, horiPitchRepeat)) {
                    j = parseInt(j, 10);
                    data2[j] = { i: j, x: 0, y: front, posX: 0, posY: 0, width: 0, height: segHeight };
                }
                let repXSeg = 0;

                gContainer
                    .selectAll(".grid-seg")
                    .raise()
                    .data(data2)
                    .enter()
                    .append("g")
                    .raise()
                    .attr("class", "grid-seg")
                    .append("rect")
                    .raise()
                    .attr("class", "rect-grid-seg")
                    .attr("width", d => {
                        d.width = parseFloat(horiPitch);
                        return horiPitch;
                    })
                    .attr("height", segHeight)
                    // .attr('stroke', 'black')
                    .attr("fill", "white")
                    .attr("fill-opacity", 0)
                    .attr("opacity", 0)
                    .attr("x", d => {
                        rx = repXSeg * horiPitch;
                        d.x = rx;
                        d.posX = repXSeg;
                        repXSeg++;
                        return d.x;
                    })
                    .attr("y", front);
            }

            let count = vertPitchRepeat * horiPitchRepeat;

            let repX = 0;
            let repY = 0;
            let rx = 0;
            let ry = 0;
            let data = [];
            for (let j in d3.range(0, count)) {
                j = parseInt(j, 10);
                data[j] = { i: j, x: 0, y: 0, posX: 0, posY: 0, width: 0, height: 0 };
            }

            gContainer
                .selectAll(".content-module")
                .raise()
                .data(data)
                .enter()
                .append("g")
                .raise()
                .attr("class", "content-module")
                .append("rect")
                .raise()
                .attr("class", "rect-content-module")
                .attr("width", d => {
                    d.width = parseFloat(horiPitch);
                    return horiPitch;
                })
                .attr("height", d => {
                    d.height = parseFloat(vertPitch);
                    return vertPitch;
                })
                .attr("stroke", "black")
                .attr("fill", "white")
                .attr("fill-opacity", 1)
                .attr("opacity", 1)
                .attr("x", d => {
                    if (d.i % horiPitchRepeat === 0) repX = 0;
                    else repX++;
                    rx = repX * horiPitch;
                    // rx = (window.innerWidth / 4) + (repX * horiPitch)
                    d.x = rx;
                    d.posX = repX;
                    return rx;
                })
                .attr("y", d => {
                    if (d.i === 0) repY = 0;
                    else if (d.i % horiPitchRepeat === 0) repY++;
                    ry = front + segHeight + repY * vertPitch;
                    d.y = ry;
                    d.posY = repY;
                    return ry;
                });

            let bb = this.gMain.node().getBBox();
            svg.attr("viewBox", "0 0 " + bb.width + " " + bb.height);
            this.$emit("listenerDrag");
            let bbContentPlanoMod = gContainer.node().getBBox();
            let nbBlock;
            if (blockWitdh === 0) {
                nbBlock = 1;
                blockWitdh = bbContentPlanoMod.width;
            } else {
                nbBlock = bbContentPlanoMod.width / blockWitdh;
            }
            gContainer
                .selectAll(".blocks")
                .data(d3.range(1, nbBlock))
                .enter()
                .append("line")
                .attr("stroke-width", 3)
                .raise()
                .attr("class", "blocks")
                .attr("x1", d => {
                    return d * blockWitdh;
                })
                .attr("x2", d => {
                    return d * blockWitdh;
                })
                .attr("y1", bbContentPlanoMod.y)
                .attr("y2", bbContentPlanoMod.height + front)
                .attr("stroke", "red");
            this.planoWModule();
        },
        getGroupByModule(module) {
            let groups = this.getGroups();
            let modules;
            let group;
            let mod;
            let groupSelect = null;
            for (let i = 0; i < groups.length; i++) {
                group = groups[i];
                modules = group.modules;

                for (let j = 0; j < modules.length; j++) {
                    mod = modules[j];
                    if (mod.groupId === module.groupId) {
                        groupSelect = group;
                        break;
                    }
                }

                if (groupSelect !== null) break;
            }
            return groupSelect;
        },
        planoWModule() {
            let isFirstLoad = false;
            if (this.getGroups().length === 0 && this.getMeuble.groups !== undefined) {
                isFirstLoad = true;
                for (let i in this.getMeuble.groups) {
                    this.getGroups().push(this.getMeuble.groups[i]);
                }
            }

            if (this.getAccessories.length === 0 && this.getMeuble.accessories instanceof Array) {
                for (let i in this.getMeuble.accessories) {
                    this.addAccessory(this.getMeuble.accessories[i]);
                }
            }
            let groups = this.getGroups();
            let accessories = this.getAccessories;
            let cmpsIsupdated = {
                datas: {}
            };
            let countTotalModule = 0;
            let countLoadModule = 0;
            groups.forEach(group => {
                group.modules.forEach(mod => {
                    let timestamp = mod.timestamp ? mod.timestamp : 0;
                    countTotalModule++;
                    cmpsIsupdated.datas[mod.id] = {
                        id: mod.id,
                        flag: false,
                        timestampModified: timestamp
                    };

                    if (cmpsIsupdated.datas[mod.id].timestampModified > timestamp) {
                        cmpsIsupdated.datas[mod.id].timestampModified = timestamp;
                    }
                });
            });

            let container = d3.select("#meubleInt").raise();
            // let groupsId = []
            this.deselectAll();
            // let self = this
            let groupsElts = {};
            let g;
            groups.forEach(group => {
                g = container.append("g");

                g.data([
                    {
                        groupId: group.id,
                        selected: false
                    }
                ]);
                groupsElts[group.id] = g;
            });

            httpService.post("/components/isupdated", JSON.stringify(cmpsIsupdated)).then(res => {
                let datas = res.datas;
                let hasSave = false;
                let canModifModule;
                groups.forEach(group => {
                    group.modules.forEach(mod => {
                        canModifModule = datas[mod.id].flag;
                        if (canModifModule && isFirstLoad) {
                            hasSave = true;
                            this.getDetails(mod)
                                .then(item => {
                                    mod.timestamp = datas[mod.id].timestampModified;
                                    let svg = this._.find(item.figures_advanced, o => {
                                        return o.id_type_file === 6;
                                    });

                                    let imgReal = this._.find(item.figures_advanced, obj => {
                                        return obj.id_type_file === 5;
                                    });
                                    let src = Globals.getBaseUrl() + svg.big;
                                    mod.src = src;
                                    mod.config = item.config;
                                    let srcreal = "";
                                    if (typeof imgReal !== "undefined") {
                                        srcreal = Globals.getBaseUrl() + imgReal.big;
                                        mod.srcreal = srcreal;
                                    }

                                    return mod;
                                })
                                .then(res => {
                                    this.createModule(res, groupsElts)
                                        .then(() => {
                                            countLoadModule++;
                                            return countLoadModule;
                                        })
                                        .then(count => {
                                            if (count === countTotalModule) {
                                                this.viewRealistic();
                                                if (hasSave) {
                                                    this.save();
                                                }
                                            }
                                        });
                                });
                        } else {
                            this.createModule(mod, groupsElts)
                                .then(() => {
                                    countLoadModule++;
                                    return countLoadModule;
                                })
                                .then(count => {
                                    if (count === countTotalModule) {
                                        this.viewRealistic();
                                        if (hasSave) {
                                            this.save();
                                        }
                                    }
                                });
                        }
                    });
                });
            });

            accessories.forEach(accessory => {
                let subtype = accessory.subtype;
                let rect =
                    subtype === "40"
                        ? this.getRectByPosition(accessory.posX, accessory.posY)
                        : this.getRectSegmentationPosition(accessory.posX, accessory.posY);
                if (rect === null) return;
                let rectData = d3.select(rect).data()[0];
                if (subtype === "40") {
                    let frame = d3
                        .select("#meubleInt")
                        .append("rect")
                        .raise()
                        .data([accessory])
                        .attr("width", rectData.width * accessory.size.width)
                        .attr("height", rectData.height * accessory.size.height)
                        .attr("stroke", accessory.color)
                        .attr("stroke-width", 10)
                        .attr("fill-opacity", 0)
                        .attr("id", accessory.UUID)
                        .attr("x", rectData.x)
                        .attr("y", rectData.y)
                        .attr("class", "accessory-frame");
                    // this.addAccessory(dataMod)
                    this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                } else if (subtype === "31") {
                    let g = d3.select("#meubleInt").append("g");
                    let widthSeg = rectData.width * accessory.size.width;
                    let frame = g
                        .append("rect")
                        .raise()
                        .data([accessory])
                        .attr("width", widthSeg)
                        .attr("height", rectData.height * accessory.size.height)
                        .attr("stroke", accessory.color)
                        .attr("stroke-width", 8)
                        .attr("fill", accessory.color)
                        .attr("id", accessory.UUID)
                        .attr("x", rectData.x)
                        .attr("y", rectData.y)
                        .attr("class", "accessory-segmentation");
                    let text = g
                        .append("text")
                        .raise()
                        .text(accessory.text)
                        .attr("x", rectData.x)
                        .attr("y", rectData.y)
                        .attr("dy", 35)
                        .attr("fill", "white")
                        .attr("font-size", rectData.height * accessory.size.height);

                    let bbText = text.node().getBBox();
                    let dx = widthSeg / 2 - bbText.width / 2;
                    text.attr("dx", dx);
                    this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                }
            });
        },
        createVirtualComponent(module, type = null) {
            let modD3 = d3.select(module);
            let data = modD3.data()[0];
            if (type === "cancel") {
                data.visual = null;
                modD3.select("rect.ret-visual-component").remove();
                return;
            }
            if (type !== null) {
                data.visual = type;
            } else {
                type = data.visual;
            }
            let types = {
                blue: "#41B4E8",
                red: "#FF0000",
                purple: "#8A2BE2",
                yellow: "#FFD700",
                green: "#008000",
                cancel: "cancel"
            };
            let colorType = types[type];
            if (!colorType) return;

            if (!data.visual) return;
            let virtuelComp = modD3.select("rect.ret-visual-component");

            if (virtuelComp.size() === 0) {
                virtuelComp = modD3
                    .append("rect")
                    .attr("class", "ret-visual-component")
                    .attr("width", "100%")
                    .attr("height", "100%")
                    .attr("opacity", 0.3)
                    .raise();
            }
            if (type !== null) {
                if (colorType) virtuelComp.attr("fill", colorType);
            }
            if (this.optionhidehighlight) {
                d3.select("#meubleInt")
                    .selectAll("rect.ret-visual-component")
                    .attr("visibility", this.optionhidehighlight ? "hidden" : "visible");
            }
            // this.highlight()
        },
        createModule(mod, groupsElts) {
            // let rect = this.getRectByPosition(accessory.posX, accessory.posY)
            // let rectData = d3.select(rect).data()[0]
            return this.eltSvg(mod.src)
                .then(domXml => {
                    let rect = this.getRectByPosition(mod.posX, mod.posY);
                    if (rect) {
                        let rectData = d3.select(rect).data()[0];

                        this.addModule(domXml);
                        let module = d3
                            .select(domXml)
                            .data([mod])
                            // .raise()
                            .attr("width", rectData.width * mod.size.width)
                            .attr("height", rectData.height * mod.size.height)
                            .attr("class", "grab module_snap")
                            .attr("x", d => {
                                d.x = rectData.x;
                                d.posX = rectData.posX;
                                return d.x;
                            })
                            .attr("y", d => {
                                d.y = rectData.y;
                                d.posY = rectData.posY;
                                return d.y;
                            })
                            .attr("id", mod.UUID);

                        // module.on('click', this.selectionModule)
                        this.drag(module, this.dragStartSVG, this.dragSVG, this.dragEndSVG);
                        return { module: mod, elt: domXml };
                    } else {
                        return null;
                    }
                })
                .then(res => {
                    if (res) {
                        let gElt = groupsElts[res.module.groupId];
                        gElt.raise();
                        gElt.node().append(res.elt);
                        this.loadConfigModule(res.elt, res.module);
                        this.createVirtualComponent(res.elt);
                        d3.select("#meubleInt")
                            .selectAll("rect.accessory-frame")
                            .raise();
                    }
                });
        },
        loadConfigModule(svg, data) {
            let config = data.config;
            if (config) {
                let i = 0;
                let validPath = d3
                    .select(svg)
                    .selectAll("g")
                    .filter(function() {
                        return d3.select(this).attr("id") === "FILL";
                    });

                validPath.selectAll("path").select(function() {
                    d3.select(this).attr("id", "path_" + i + "_" + data.UUID);
                    i = i + 1;
                });

                let self = this;
                let rowId;

                self._.forEach(config.groups, function(ensemble, k) {
                    rowId = "row_" + (k + "" + 1) + "_" + data.UUID;
                    let d3E = d3
                        .select(svg)
                        .select("#FILL")
                        .append("g")
                        .attr("id", rowId);
                    // ensemble.rowId = rowId
                    self._.forEach(ensemble.modules, function(path, kk) {
                        let temp = d3
                            .select("#" + path + "_" + data.UUID)
                            .classed("grouped", true)
                            .classed(rowId, true);
                        if (path === ensemble.tester) {
                            temp.classed("tester", true); // .attr('id', 'row_tester_' + k + '_' + kk)
                        }
                        d3E.append(function() {
                            return temp.node();
                        });
                    });
                    // self.ng = k + 1
                });

                /*
                 * Ajout des textes
                 * */

                let texts = ["ETIQUETTE_TEXTES", "ETIQUETTE_TEXTE", "TEXTES", "TEXTS", "TEXT", "TEXTE_ETIQUETTE"];
                let etiquettes = ["ETIQUETTES"];

                etiquettes.forEach(eti => {
                    d3.selectAll("g#" + eti).attr("id", "ETIQUETTE");
                    d3.selectAll("g#" + eti.toLowerCase()).attr("id", "ETIQUETTE");
                });
                texts.forEach(text => {
                    d3.selectAll("g#" + text).attr("id", "TEXTE");
                    d3.selectAll("g#" + text.toLowerCase()).attr("id", "TEXTE");
                });

                let d3T = d3.select(svg).select("#TEXTE");
                let d3C = d3.select(svg).select("#ETIQUETTE");
                let xT = 10;
                let yT = 10;
                let rectCoords = d3C.node().getBBox();
                d3T.selectAll("text").remove();
                self._.forEach(config.texts, function(text, k) {
                    if (k === "name") {
                        d3T.append("text")
                            .attr("x", rectCoords.x + rectCoords.width / 2)
                            .attr("y", rectCoords.y + 30 + yT)
                            .attr("width", rectCoords.width)
                            .attr("height", rectCoords.height)
                            .attr("alignment-baseline", "ideographic")
                            .attr("text-anchor", "middle")
                            .text(text !== null ? text.substr(0, 29) : "empty nickname");
                    } else if (k === "refs") {
                        self._.forEach(text, function(ref, refK) {
                            let ta = "";
                            let dx = rectCoords.x;
                            if (refK === "DIAM") {
                                ta = "end";
                                dx = dx + rectCoords.width - xT;
                            } else {
                                ta = "start";
                                dx = dx + xT;
                            }
                            d3T.append("text")
                                .attr("x", dx)
                                .attr("y", rectCoords.y + rectCoords.height)
                                .attr("width", rectCoords.width)
                                .attr("height", rectCoords.height)
                                .attr("alignment-baseline", "ideographic")
                                .attr("text-anchor", ta)
                                .classed("text" + refK, true)
                                .text(ref);
                        });
                    }
                });

                if (this.modeShades !== "blackwhite") {
                    this.loadColor(svg, data);
                }
            }
        },
        loadColor(svg, data) {
            if (!data.config.groups) {
                console.error("La config du module id: " + data.id + " elt id: " + data.UUID + " est erroné veuillé le reconfiguré");
                return;
            }
            let configs = data.config.groups;
            let color;
            let paths, path;
            let parent, bb, text;
            configs.forEach(config => {
                color = config.color;
                if (color !== null && color !== undefined) {
                    parent = d3.select(svg).select("g#" + config.rowId + "_" + data.UUID);
                    parent.data([color]);
                    paths = parent.selectAll("path");
                    paths.each((d, i, cmps) => {
                        path = d3.select(cmps[i]);
                        if (path.attr("id") === config.tester + "_" + data.UUID) {
                            path.raise();
                            bb = path.node().getBBox();
                            path.attr("fill", "white").style("fill", "white");

                            text = parent.select("text");
                            if ((text.size() === 0 && this.modeShades === "shades") || this.modeShades === "iconscolors") {
                                text = parent.append("text");
                            }

                            text.raise()
                                .attr("x", bb.x + bb.width / 2)
                                .attr("y", bb.y + (bb.height / 5) * 4)
                                .attr("font-size", "20px")
                                .attr("text-anchor", "middle")
                                .text(color.ref);
                        } else if (this.modeShades === "iconscolors") {
                            path.attr("fill", color.color).style("fill", color.color);
                        }
                    });
                }
            });
        },
        eltSvg(url) {
            let promise = new Promise((resolve, reject) => {
                d3.xml(url)
                    .mimeType("image/svg+xml")
                    .get((error, xml) => {
                        if (error) {
                            reject(error);
                        }
                        resolve(xml.documentElement);
                    });
            });

            return promise;
        },
        views(a, event) {
            this.upBuilderField("displayMode", a);
            if (a === "realistic") this.realistic = !this.realistic;
            else if (a === "hide") this.tabhide = !this.tabhide;
            else this.rollIndex = a;

            this.selectionAction();
            if (a === "realistic") {
                this.viewRealistic();
            } else if (a === "iconscolors") {
                this.modeShades = a;
                this.redrawPlano();
                d3.selectAll("#meubleInt")
                    .selectAll("image")
                    .remove("class", "realistic");
            } else if (a === "shades" || a === "blackwhite") {
                this.modeShades = a;
                this.redrawPlano();
                d3.selectAll("#meubleInt")
                    .selectAll("image")
                    .remove("class", "realistic");
            } else if (a === "shades") {
                this.modeShades = a;
                this.redrawPlano();
                d3.selectAll("#meubleInt")
                    .selectAll("image")
                    .remove("class", "realistic");
            } else if (a === "hide") {
                // d3.select('#meubleInt').selectAll('rect.accessory-frame').attr('visibility', this.tabhide ? 'hidden' : 'visible')
                // this.modeShades = a
                this.hideMenu(event);
            } else {
                d3.selectAll("#meubleInt")
                    .selectAll("image")
                    .remove("class", "realistic");
            }
        },
        viewRealistic() {
            let reals = d3.select("#meubleInt").selectAll(".img-realistic");
            if (this.realistic) {
                if (reals.size() === 0) {
                    for (let i in this.getGroups()) {
                        for (let j in this.getGroups()[i].modules) {
                            let x = this.getGroups()[i].modules[j].posX;
                            let y = this.getGroups()[i].modules[j].posY;
                            let rect = this.getRectByPosition(x, y);
                            if (rect === null) continue;
                            let rectData = d3.select(rect).data()[0];
                            d3.select("#meubleInt")
                                .append("svg:image")
                                .attr("class", "img-realistic")
                                .attr("x", rectData.x)
                                .attr("y", rectData.y)
                                .attr("width", rectData.width * this.getGroups()[i].modules[j].size.width)
                                .attr("height", rectData.height * this.getGroups()[i].modules[j].size.height)
                                .attr("xlink:href", this.getGroups()[i].modules[j].srcreal);
                        }
                    }
                } else {
                    reals.attr("visibility", "visible");
                }
            } else {
                reals.attr("visibility", "hidden");
            }
        },
        redrawPlano() {
            this.deselectAll();
            this.deleteAllModulesElt();
            d3.select("svg#builder")
                .select("g#planoMeuble")
                .remove();
            d3.select("svg#builder")
                .select("g#meubleInt")
                .remove();
            this.plano();
        },
        destroyMenu(className = null) {
            d3.select("div.content-menu-item").remove();
            d3.select("div.content-menu").remove();
            d3.select("div.content-menu-hide").remove();
        },
        createMenu(items, menuItem = false, menuHide = false, event = null) {
            event = event === null ? d3.event : event;
            let x = event.clientX;
            let y = event.clientY;
            d3.select("div.content-menu-item").remove();
            if (menuItem === false) {
                d3.select("div.content-menu").remove();
            }

            let contentMenu = document.createElement("div");
            let className = menuItem ? "content-menu content-menu-item" : "content-menu";
            if (menuHide) {
                className = "content-menu-hide";
            }

            contentMenu.className = className;
            contentMenu.style.left = x + "px";
            contentMenu.style.top = y + "px";
            let addclass = "";
            items.forEach(item => {
                let itemElt = document.createElement("div");
                if (item.addClass) {
                    addclass = " " + item.addClass;
                }
                itemElt.className = (menuItem ? "parent-item-menu menu-item" : "menu-item") + addclass;
                let label = "";
                if (item.label instanceof String) {
                    label = this.$t(item.label);
                } else {
                    label = item.label[i18n.locale];
                }
                itemElt.appendChild(document.createTextNode(label));
                contentMenu.appendChild(itemElt);
                let args = null;
                let event = item.event === undefined ? "click" : item.event;
                d3.select(itemElt).on("mouseover", (d, i, cmps) => {
                    if (!d3.event.target.className.includes("parent-item-menu")) {
                        d3.select("div.content-menu-item").remove();
                    }
                });
                d3.select(itemElt).on(event, e => {
                    args = item.args === undefined ? null : item.args;
                    if (args !== null) item.action.apply(this, args);
                    else item.action.apply(this, args);
                });
            });

            document.body.appendChild(contentMenu);

            d3.select("body").on("click", () => {
                if (menuHide === true) {
                    if (this.tabhide === false) d3.selectAll("div.content-menu-hide").remove();
                } else {
                    d3.selectAll("div.content-menu").remove();
                }
            });
        },
        hideMenu(event) {
            let classNameFrameHide = (this.optionhideframe ? "hide-option-selected " : "") + "hide-frame";
            let classNameHighlightHide = (this.optionhidehighlight ? "hide-option-selected " : "") + "hide-highlights";
            let items = [
                {
                    id: "frameHide",
                    action: this.frameHide,
                    addClass: classNameFrameHide,
                    label: {
                        fr: "Cacher cadre",
                        en: "Frame hide"
                    }
                },
                {
                    id: "highlights",
                    action: this.highlight,
                    addClass: classNameHighlightHide,
                    label: {
                        fr: "Cacher Highlights",
                        en: "Highlights hide"
                    }
                }
            ];
            this.createMenu(items, false, true, event);
        },
        frameHide() {
            this.optionhideframe = !this.optionhideframe;
            // d3.select('.content-menu-hide').select('.hide-frame').attr()
            let elt = document.querySelector(".content-menu-hide .hide-frame");

            if (this.optionhideframe) elt.classList.add("hide-option-selected");
            else elt.classList.remove("hide-option-selected");

            d3.select("#meubleInt")
                .selectAll("rect.accessory-frame")
                .attr("visibility", this.optionhideframe ? "hidden" : "visible");
            this.modeShades = "hide";
        },
        highlight() {
            this.optionhidehighlight = !this.optionhidehighlight;
            this.modeShades = "hide";

            let elt = document.querySelector(".content-menu-hide .hide-highlights");

            if (this.optionhidehighlight) elt.classList.add("hide-option-selected");
            else elt.classList.remove("hide-option-selected");

            d3.select("#meubleInt")
                .selectAll("rect.ret-visual-component")
                .attr("visibility", this.optionhidehighlight ? "hidden" : "visible");
        }
    },
    computed: {
        ...Vuex.mapGetters({
            getModuleEdit: "plano/status/getModuleEdit",
            getMeuble: "plano/data/getMeuble",
            getSelection: "plano/status/getSelection",
            getSelectModules: "plano/status/getSelectModules",
            countSelectModules: "plano/status/countSelectModules",
            getGroups: "plano/status/getGroups",
            getGroupSelected: "plano/status/getGroupSelected",
            getModules: "plano/status/getModules",
            getPositionModule: "plano/status/getPositionModule",
            getAccessories: "plano/status/getAccessories",
            getAccessoriesSelected: "plano/status/getAccessoriesSelected"
        })
    },
    mounted() {
        /* A GARDER NE PAS EFFACER */
        // svg.addEventListener('click', function (event) {
        //     let test = event.target.attributes[2].nodeValue
        //     let id = test.split('_')[1]
        //     window.location.replace('/param_module/' + id)  // let test = event.target.attributes[2].nodeValue
        //     self.upBuilderField('mode', 'module')
        // })
        // this.$on('listenerDrag', function () {
        //     // d3.zoom().scaleTo(this.gMain, 10)
        //     this.gMain.call(d3.zoom().scaleExtent([1, 10]).on('zoom', (d, i, cmps) => {
        //         let transform = d3.event.transform
        //
        //         // if (transform.k === 1) {
        //         //     transform.x = 0
        //         //     transform.y = 0
        //         // }
        //
        //         d.transform = transform
        //
        //         this.gMain.attr('transform', transform)
        //     }))
        // })
    },
    created() {}
};



// WEBPACK FOOTER //
// ./src/components/planoold/mixins/builder.js